export const EMPTY_VALUE = 'Not set';

export const formatEmptyValue = (value?: string | null): string => {
  const normalized = String(value || '').trim();
  return normalized ? normalized : EMPTY_VALUE;
};

export const formatDateTime = (value?: string | null): string => {
  if (!value) return EMPTY_VALUE;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return EMPTY_VALUE;
  return new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};

export const formatDate = (value?: string | null): string => {
  if (!value) return EMPTY_VALUE;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return EMPTY_VALUE;
  return new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
};

export const formatRelative = (value?: string | null): string => {
  if (!value) return EMPTY_VALUE;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return EMPTY_VALUE;
  const deltaMinutes = Math.round((date.getTime() - Date.now()) / (60 * 1000));
  const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  if (Math.abs(deltaMinutes) < 60) return formatter.format(deltaMinutes, 'minute');
  const deltaHours = Math.round(deltaMinutes / 60);
  if (Math.abs(deltaHours) < 48) return formatter.format(deltaHours, 'hour');
  const deltaDays = Math.round(deltaHours / 24);
  return formatter.format(deltaDays, 'day');
};

export const formatNumber = (value?: number | null): string => {
  return new Intl.NumberFormat('en-CA').format(Number(value || 0));
};

export const formatList = (values?: Array<string | null | undefined> | null): string => {
  const cleaned = Array.isArray(values)
    ? values.map((entry) => String(entry || '').trim()).filter(Boolean)
    : [];
  return cleaned.length ? cleaned.join(', ') : EMPTY_VALUE;
};

export const toInitials = (...values: Array<string | null | undefined>): string => {
  const tokens = values
    .flatMap((value) => String(value || '').split(/\s+/))
    .map((token) => token.trim())
    .filter(Boolean)
    .slice(0, 2);
  if (!tokens.length) return 'EC';
  return tokens.map((token) => token.charAt(0).toUpperCase()).join('');
};

export const isOverdue = (value?: string | null): boolean => {
  if (!value) return false;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return false;
  return date.getTime() < Date.now();
};
